import {
    FETCH_MEDICLAIM_DETAILS_REQUEST,
    FETCH_MEDICLAIM_DETAILS_SUCCESS,
    FETCH_MEDICLAIM_DETAILS_FAILURE,
  } from "./FetchMediclaimDetailsTypes";
  
  const initialState = {
    loading: false,
    mediclaimDetails: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_MEDICLAIM_DETAILS_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_MEDICLAIM_DETAILS_SUCCESS:
        return {
          loading: false,
          mediclaimDetails: action.payload,
          error: "",
        };
      case FETCH_MEDICLAIM_DETAILS_FAILURE:
        return {
          loading: false,
          mediclaimDetails: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  